import Vue from 'vue'
import Router from 'vue-router'
//导入全局 nprogress 跳转动效
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
//用法
// NProgress.start();
// NProgress.done();

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题--来自H
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)

const router = new Router({
  routes: [{ //贝贝猫首页
      path: '/',
      name: 'container',
      meta: {
        isLogin: false,
        title: "首页"
      },
      component: resolve => {
        require(['@/views/index'], resolve)
      },
      children: [{
          path: '/',
          name: "index",
          meta: {
            isLogin: false,
            title: "首页"
          },
          component: resolve => {
            require(['@/views/homePage/index'], resolve)
          },
        }, {
          path: '/categroy',
          name: "categroy",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/homePage/categroy_list'], resolve)
          },
        }, {
          path: '/goodsList',
          name: "goodsList",
          meta: {
            isLogin: false,
            title: "商品列表"

          },
          component: resolve => {
            require(['@/views/homePage/goods/goodsList'], resolve)
          },
        }, {
          path: '/material',
          name: "material",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/homePage/material'], resolve)
          },
        }, {
          path: '/searchList',
          name: "searchList",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/homePage/searchValue'], resolve)
          },
        },
        {
          path: '/myLeader',
          name: "myLeader",
          meta: {
            isLogin: false,
            title: "我的代理"
          },
          component: resolve => {
            require(['@/views/homePage/my_leader.vue'], resolve)
          },
        },
        {
          path: '/allShop',
          name: "allShop",
          meta: {
            isLogin: false,
            title: "全国店"
          },
          component: resolve => {
            require(['@/views/homePage/shopChinaList.vue'], resolve)
          },
        },
        { // 去使用优惠券
          path: '/couponProductList',
          name: 'couponProductList',
          component: resolve => {
            require(['@/views/homePage/goods/couponProductList'], resolve)
          },
        },
        { // 拼团
          path: '/groupBuying',
          name: 'groupBuying',
          component: resolve => {
            require(['@/views/homePage/group_buying'], resolve)
          },
        },

      ]
    },
    { //订单页面
      path: '/order',
      name: 'order',
      component: resolve => {
        require(['@/views/backstage/index'], resolve)
      },
      children: [{
          path: '/messageCenter',
          name: "messageCenter",
          meta: {
            title: "消息中心"
          },
          component: resolve => {
            require(['@/views/backstage/messageCenter'], resolve)
          },
        },
        {
          path: '/user_setting',
          name: "setting",
          meta: {
            title: "账户基本信息"
          },
          component: resolve => {
            require(['@/views/backstage/setting'], resolve)
          },
        },
        { //会员 
          path: '/order/vip/eaccount_book',
          name: "EaccountBook",
          meta: {
            title: "e账簿"
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/EaccountBook'], resolve)
          },
        },
        { //商户
          path: '/order/shop/eaccount_book',
          name: "EaccountBook",
          meta: {
            title: "e账簿"
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/EaccountBook'], resolve)
          },
        },
        { //商户托管
          path: '/order/shop/EAcountDeposit',
          name: "EAcountDeposit",
          meta: {
            title: "e账簿托管"
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/EAcountDeposit'], resolve)
          },
        },
         {
          path: '/order/shop_index',
          name: "shop_index",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/index'], resolve)
          },
        }, {
          path: '/order/user_index',
          name: "user_index",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/index'], resolve)
          },
        }, {
          path: '/order/inGroup',
          name: "inGroup",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/inGroup'], resolve)
          },
        },
        {
          path: '/order/inGroupVip',
          name: "inGroupVip",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/inGroupVip'], resolve)
          },
        }, { // 开通会员
          path: '/order/open_server',
          name: "userOpenServer",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/open_server'], resolve)
          },
        }, { //购买会员
          path: '/order/buy_server',
          name: "userBuyServer",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/buy_server'], resolve)
          },
        }, { //待审核
          path: '/order/under_review',
          name: "underReview",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/under_review'], resolve)
          },
        }, { // 账户信息
          path: '/order/user_info',
          name: "userInfo",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/user_info'], resolve)
          },
        },
        { // 开通店铺 签订合同
          path: '/order/open_shop_second',
          name: "useropen_shop_secondInfo",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/open_shop_second'], resolve)
          },
        }, { // 开通店铺 绑定银行卡
          path: '/order/open_shop_third',
          name: "open_shop_third",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/open_shop_third'], resolve)
          },
        }, { // 开通店铺 付款
          path: '/order/open_shop_four',
          name: "open_shop_four",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/open_shop_four'], resolve)
          },
        }, { //账户安全
          path: '/order/setting',
          name: "setting",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/setting'], resolve)
          },
        },
        { //
          path: '/order/apply_detail',
          name: "apply_detail",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/apply_detail'], resolve)
          },
        }, { //账户安全
          path: '/order/vip_index',
          name: "vipIndex",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/index'], resolve)
          },
        }, { //店铺首页
          path: '/order/shop_index',
          name: "shopIndex",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/index'], resolve)
          },
        }, { //店铺 发布商品
          path: '/order/shop/upload_product',
          name: "uploadProduct",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/upload_product'], resolve)
          },
        }, { //店铺 发布商品
          path: '/order/shop/updata_product',
          name: "updataProduct",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/updata_product'], resolve)
          },
        }, { //店铺 商品管理
          path: '/order/shop/product_control',
          name: "vipproductControl",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/product_control'], resolve)
          },
        }, 
        { //店铺 仓库管理
          path: '/order/shop/store_management',
          name: "仓库管理",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/store_management'], resolve)
          },
        },
        { //店铺 价格管理
          path: '/order/shop/control_pro_price',
          name: "controlProPrice",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_pro_price'], resolve)
          },
        },
        { //店铺 客服设置
          path: '/order/shop/after_sale_setting',
          name: "afterSaleSetting",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/after_sale_setting'], resolve)
          },
        },
        { //店铺 经销商管理
          path: '/order/shop/control_dealer',
          name: "controlDealer",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_dealer'], resolve)
          },
        },
        // IE浏览器兼容页面


        { //店铺 商品预警
          path: '/order/shop/product_early_warning',
          name: "productEarlyWarning",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/product_early_warning'], resolve)
          },
        },
        { //店铺 店铺装修
          path: '/order/shop/control_shop_trim',
          name: "controlShopTrim",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_shop_trim'], resolve)
          },
        },
        { //店铺 供应商管理
          path: '/order/shop/control_supplier',
          name: "controlSupplier",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_supplier'], resolve)
          },
        },


        // ie浏览器兼容页面
        { //店铺 商品分类管理
          path: '/order/shop/control_product_sort',
          name: "controlProductSort",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_product_sort'], resolve)
          },
        }, { //店铺 首页管理
          path: '/order/shop/control_index',
          name: "controlIndex",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_index'], resolve)
          },
        }, { //店铺 店铺管理
          path: '/order/shop/control_shop',
          name: "controlShop",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_shop'], resolve)
          },
        }, { //店铺 开新业务
          path: '/order/shop/new_business',
          name: "new_business",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/open_new_business1'], resolve)
          },
        }, { //店铺 开新业务
          path: '/order/shop/new_business1',
          name: "new_business1",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/open_new_business2'], resolve)
          },
        },
        { //店铺 开新业务 签合同
          path: '/order/shop/new_business_two',
          name: "new_business_two",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/open_new_business_two'], resolve)
          },
        }, { //店铺 开新业务 缴费
          path: '/order/shop/new_business_thir',
          name: "open_new_business_two",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/open_new_business_thir'], resolve)
          },
        },
        { //店铺 成员管理
          path: '/order/shop/member_control',
          name: "vipmemberControl",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/member_control'], resolve)
          },
        }, { //店铺 开新业务 开通明细
          path: '/order/shop/new_business_detail',
          name: "new_business_detail",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/open_new_business_detail'], resolve)
          },
        }, { //店铺 材料包管理
          path: '/order/shop/control_material',
          name: "open_new_business_detail",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_material'], resolve)
          },
        },
        { //店铺 促销活动
          path: '/order/shop/control_promotion',
          name: "control_material",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_promotion'], resolve)
          },
        },
        { //店铺 优惠券管理
          path: '/order/shop/control_coupon',
          name: "control_promotion",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_coupon'], resolve)
          },
        },
        { //店铺 订单管理
          path: '/order/shop/control_order',
          name: "control_order",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_order'], resolve)
          },
        },
        { //店铺 暖通商讯
          path: '/order/shop/managementBusiness',
          name: "暖通商讯管理",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/managementBusiness'], resolve)
          },
        },  
        { //店铺 拍照采购管理
          path: '/order/shop/photo_order',
          name: "制单",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/photo_order'], resolve)
          },
        }, 
        { //泰隆银行店铺 订单管理
          path: '/order/shop/tailong_order',
          name: "tailong_order",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/tailong_order'], resolve)
          },
        },
        { //店铺 代理管理
          path: '/order/shop/control_agent',
          name: "control_agent",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_agent'], resolve)
          },
        }, { //店铺 发布代理商广告
          path: '/order/shop/control_agent_index',
          name: "control_agent_index",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_agent_index'], resolve)
          },
        }, { //店铺 地址管理
          path: '/order/shop/control_position',
          name: "control_position1",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/control_position'], resolve)
          },
        },
        { //店铺 账套安全
          path: '/order/shop/setting',
          name: "setting_shop",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/setting'], resolve)
          },
        },
        { //店铺 余额
          path: '/order/shop/balance',
          name: "balance",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/shop_balance'], resolve)
          },
        }, { //店铺 聚集利订单
          path: '/order/inGroupShop',
          name: "inGroup",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/inGroupShop'], resolve)
          },
        }, { //会员 余额
          path: '/order/vip/balance',
          name: "inGroupShop",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/vip_balance'], resolve)
          },
        }, { //个人 开通
          path: '/order/open_shop',
          name: "openShop",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/userInfo/open_shop'], resolve)
          },
        }, { //会员 成员管理
          path: '/order/vip/member_control',
          name: "member_control",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/member_control'], resolve)
          },
        }, { //会员 账套信息
          path: '/order/vip/user_info',
          name: "user_info",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/user_info'], resolve)
          },
        }, { //会员 账套安全
          path: '/order/vip/setting',
          name: "vipSetting",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/setting'], resolve)
          },
        },
        { //会员 我的优惠券
          path: '/order/vip/control_coupon',
          name: "control_coupon",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/control_coupon'], resolve)
          },
        },
        { //会员 委托采购
          path: '/order/vip/pro_order',
          name: "pro_order",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/pro_order'], resolve)
          },
        },
        { //会员 个人订单
          path: '/order/vip/self_order',
          name: "self_order",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/self_order'], resolve)
          },
        }, { //会员 个人订单
          path: '/order/vip/vip_order',
          name: "vip_order",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/vip_order'], resolve)
          },
        },
        { //会员暖通商讯
          path: '/order/vip/managementBusiness',
          name: "暖通商讯",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/managementBusiness'], resolve)
          },
        },
        { //地址管理
          path: '/order/control_position',
          name: 'control_positionshop',
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/control_position'], resolve)
          },
        },
        { // 账套流水 会员
          path: '/vipSuit/catipalFlow',
          name: "catipalFlow",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/catipalFlow_v.vue'], resolve)
          },
        },
        { // 账套流水 店铺
          path: '/shopSuit/catipalFlow',
          name: "catipalFlow",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/catipalFlow_s.vue'], resolve)
          },
        },
        { // 提现记录 会员
          path: '/vip/withdrawal_record',
          name: "withdrawal_record",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/vipInfo/withdrawal_record.vue'], resolve)
          },
        },
        { // 销售统计
          path: '/shop/dataStatistics',
          name: "dataStatistics",
          meta: {
            isLogin: false
          },
          component: resolve => {
            require(['@/views/backstage/shopInfo/bbm_visualization.vue'], resolve)
          },
        },
      ]
    },
    { //登录页面
      path: '/login',
      name: 'login',
      component: resolve => {
        require(['@/views/login'], resolve)
      },
    },
    { //支付密码
      path: '/pay',
      name: "pay",
      meta: {
        isLogin: false
      },
      component: resolve => {
        require(['@/views/cashierDesk'], resolve)
      },
    },
    { //优惠券
      path: '/coupon_list',
      name: "coupon_list",
      meta: {
        isLogin: false
      },
      component: resolve => {
        require(['@/views/homePage/coupon_list'], resolve)
      },
    },
    { //收藏列表
      path: '/collect_list',
      name: "collect_list",
      meta: {
        isLogin: false
      },
      component: resolve => {
        require(['@/views/homePage/collect_list'], resolve)
      },
    },
    { //商品详情
      path: '/goodsDetail',
      name: "goodsDetail",
      meta: {
        isLogin: false
      },
      component: resolve => {
        require(['@/views/homePage/goods/goodsDetails'], resolve)
      },
    },
    { //暖通商讯
      path: '/businessIndex',
      name: "暖通商讯首页",
      meta: {
        isLogin: false
      },
      component: resolve => {
        require(['@/views/homePage/businessIndex'], resolve)
      },
    },
    { // 团购商铺详情
      path: '/groupBuyDetail',
      name: "groupBuyDetail",
      meta: {
        isLogin: false
      },
      component: resolve => {
        require(['@/views/homePage/goods/groupBuyDetail'], resolve)
      },
    },
    { //进货单
      path: '/purchase_order',
      name: "purchase_order",
      meta: {
        isLogin: false
      },
      component: resolve => {
        require(['@/views/homePage/order/purchase_order'], resolve)
      },
    },




    { //确认订单 
      path: '/confirm_order',
      name: "confirm_order",
      meta: {
        isLogin: false
      },
      component: resolve => {
        require(['@/views/homePage/order/confirm_order'], resolve)
      },
    },
    { //聚集利 确认订单 
      path: '/group_confirm_order',
      name: "group_confirm_order",
      meta: {
        isLogin: false
      },
      component: resolve => {
        require(['@/views/homePage/order/group_confirm_order'], resolve)
      },
    },




    { //微信支付 
      path: '/wx_pay',
      name: "wx_pay",
      meta: {
        isLogin: false
      },
      component: resolve => {
        require(['@/views/wx_pay'], resolve)
      },
    },
    { //支付宝支付 
      path: '/ali_pay',
      name: "ali_pay",
      meta: {
        isLogin: false
      },
      component: resolve => {
        require(['@/views/ali_pay'], resolve)
      },
    },
    { //店铺首页
      path: '/shopIndex',
      name: "Index",
      meta: {
        isLogin: false,
        title: "店铺首页"
      },
      component: resolve => {
        require(['@/views/homePage/shop/index'], resolve)
      },
      children: [{ //店铺首页
        path: '/shopIndex/index',
        name: "shop",
        meta: {
          isLogin: false,
          title: "店铺首页"
        },
        component: resolve => {
          require(['@/views/homePage/shop/buy'], resolve)
        },
      }, { //快速采购模式
        path: '/shopIndex/quily',
        name: "shopQuily",
        meta: {
          isLogin: false
        },
        component: resolve => {
          require(['@/views/homePage/shop/quily_buy'], resolve)
        },
      }, { //专属价格
        path: '/shopIndex/only',
        name: "shoponly",
        meta: {
          isLogin: false
        },
        component: resolve => {
          require(['@/views/homePage/shop/only_price'], resolve)
        },
      }, { // 代理价
        path: '/shopIndex/learPro',
        name: "learPro",
        meta: {
          isLogin: false
        },
        component: resolve => {
          require(['@/views/homePage/shop/lear_product'], resolve)
        },
      }, { // 申请代理
        path: '/shopIndex/addly_dealer',
        name: "addly_dealer",
        meta: {
          isLogin: false
        },
        component: resolve => {
          require(['@/views/homePage/shop/apply_dealer.vue'], resolve)
        },
      }, ]
    },


    { // 在线课堂
      path: '/classRoom',
      name: 'classRoom',
      component: resolve => {
        require(['@/views/homePage/classRoom'], resolve)
      },
    },
    { // 帮助中心
      path: '/helpCenter',
      name: 'helpCenter',
      component: resolve => {
        require(['@/views/homePage/helpCenter'], resolve)
      },
    },
    { // 关于我们
      path: '/aboutAs',
      name: 'aboutAs',
      component: resolve => {
        require(['@/views/homePage/aboutAs'], resolve)
      },
    },
    { // 去使用优惠券
      path: '/classRoomDetail',
      name: 'classRoomDetail',
      component: resolve => {
        require(['@/views/homePage/classRoomDetail'], resolve)
      },
    },
    { // 去使用优惠券
      path: '/H5',
      name: 'H5',
      component: resolve => {
        require(['@/views/homePage/H5'], resolve)
      },
    },
    { // 注册协议
      path: '/register_agreement',
      name: 'register_agreement',
      component: resolve => {
        require(['@/views/register_agreement'], resolve)
      },
    },
    { // 网络错误
      path: '/network_error',
      name: 'network_error',
      component: resolve => {
        require(['@/views/network_error'], resolve)
      },
    },
    { // 银行支付
      path: '/bank_pay',
      name: 'bank_pay',
      component: resolve => {
        require(['@/views/bank_pay'], resolve)
      },
    },
    { // 注册会员
      path: '/register_vip',
      name: 'register_vip',
      component: resolve => {
        require(['@/views/register_vip'], resolve)
      },
    },
    { // 会员完善信息
      path: '/register_vip_two',
      name: 'register_vip_two',
      component: resolve => {
        require(['@/views/register_vip_two'], resolve)
      },
    },
    { // 注册商户
      path: '/register_shop',
      name: 'register_shop',
      component: resolve => {
        require(['@/views/register_shop'], resolve)
      },
    },
    { // 商户注册介绍
      path: '/register_shop_before',
      name: 'register_shop_before',
      component: resolve => {
        require(['@/views/register_shop_before'], resolve)
      },
    },
    { // 填写商户信息
      path: '/register_shop_info',
      name: 'register_shop_info',
      component: resolve => {
        require(['@/views/register_shop_info'], resolve)
      },
    },
    { // 注册商户未完成 待付款
      path: '/shop_index_third',
      name: 'shop_index_third',
      component: resolve => {
        require(['@/views/shop_index_third'], resolve)
      },
    },
    { // 注册商户未完成 签订中
      path: '/shop_index_two',
      name: 'shop_index_two',
      component: resolve => {
        require(['@/views/shop_index_two'], resolve)
      },
    },
    { // 注册商户未完成
      path: '/shop_index',
      name: 'shop_index1',
      component: resolve => {
        require(['@/views/shop_index'], resolve)
      },
    },
    { //页面重定向
      path: '*',
      redirect: '/network_error',
      name: '',
    }
  ]
})
// 全局前置守卫
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.meta.isLogin) { //判断是否需要登录
    if (localStorage.getItem('token')) {
      var token = localStorage.getItem('token')
      store.commit('SET_TOKEN', token);
      next();
    } else {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('token')
      localStorage.removeItem('defaultActiveUrl')
      localStorage.removeItem('shop_status')
      localStorage.removeItem('userMenuList')
      localStorage.removeItem('suitId')

      store.commit('REMOVE_TOKEN')
      next({
        path: "/login"
      });
    }
  } else {
    next()
  }
});
// 全局后置守卫
router.afterEach(() => {
  NProgress.done()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js